export default "__VITE_ASSET__CpqMt6Dx__"